"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _debounce = _interopRequireDefault(require("./debounce"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
var EventSpy = /*#__PURE__*/
function (_React$Component) {
  _inherits(EventSpy, _React$Component);
  function EventSpy(props, context) {
    var _this;
    _classCallCheck(this, EventSpy);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(EventSpy).call(this, props, context));
    _this.createDebouncer();
    _this.handleEvent = _this.handleEvent.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }
  _createClass(EventSpy, [{
    key: "createDebouncer",
    value: function createDebouncer() {
      var _this2 = this;
      this.debouncer = (0, _debounce.default)(function (event) {
        _this2.props.onEvent && _this2.props.onEvent(event);
      }, this.props.debounce);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var target = this.props.target;
      if (target) {
        target.addEventListener(this.props.name, this.handleEvent, {
          passive: true
        });
        this.handleEvent({
          target: target,
          type: this.props.name
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevName = prevProps.name,
        prevTarget = prevProps.target;
      var _this$props = this.props,
        name = _this$props.name,
        target = _this$props.target;
      if (target !== prevTarget || name !== prevName) {
        if (prevTarget) {
          prevTarget.removeEventListener(prevName, this.handleEvent);
        }
        if (target) {
          target.addEventListener(name, this.handleEvent, {
            passive: true
          });
          this.handleEvent({
            target: target,
            type: this.props.name
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var target = this.props.target;
      target && target.removeEventListener(this.props.name, this.handleEvent);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var nextDebounce = _ref.debounce;
      if (this.props.debounce !== nextDebounce) {
        this.createDebouncer();
      }
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(event) {
      event.timeStampLow = Date.now();
      this.debouncer(event);
    }
  }, {
    key: "render",
    value: function render() {
      return false;
    }
  }]);
  return EventSpy;
}(_react.default.Component);
exports.default = EventSpy;
EventSpy.defaultProps = {
  debounce: 200
};